export const ADMIN_TASK_SCHEDULER_LIST_PATH = "/admin/task-scheduler";

export const ADMIN_TASK_SCHEDULER_NEW_PATH = "/admin/task-scheduler/new";

export function adminTaskSchedulerEditPath(id) {
    return `/admin/task-scheduler/edit/${id}`;
}
